import type {ProgramCompositionObservation} from '@ohmyprime/segmenter';
import type {Project} from '../core/model';
import type {GamingSession} from '../net/api';
import type {RenderSourceLease} from './creator-source';

/** Local capabilities only. They never enter project persistence or Portal RPC. */
export type CreatorConnectionIdentity = 'absent' | Readonly<{
 identity: object;
 generation: number;
 presenceId?:string;installationId?:string;instanceId?:string;port?:number;browserSessionId?:string;pageNonce?:string;
 current(): boolean;
}>;
export type CreatorQualificationContext = Readonly<{
 session: Readonly<GamingSession>;
 project(): Readonly<Project>;
 mounted(): Readonly<{producerId:string;lease:RenderSourceLease;connection:CreatorConnectionIdentity}> | undefined;
 audio(): Readonly<{identity:object;state:AudioContextState;sampleRate:number;currentFrame:number}>;
 visible(): boolean;
 /** Owned lifecycle only: must never call the qualification proof itself. */
 current(): boolean;
 programSourceId?():string|undefined;
}>;
export type CreatorQualificationProof = Readonly<{
 profile?:'monotonic-causal-v1';
 current(): boolean;
 validateComposition(value: Readonly<ProgramCompositionObservation>): void;
}>;
export type CreatorQualifier = (context: CreatorQualificationContext) => CreatorQualificationProof|Promise<CreatorQualificationProof>;

/** Both calls fail permanently after any owner/model loss, including reentrant replacement. */
export function fenceCreatorQualification(proof:CreatorQualificationProof,ownerCurrent:()=>boolean):CreatorQualificationProof {
 let revoked=false;
 const current=()=>{
  if(revoked)return false;
  try{if(!ownerCurrent()||typeof proof.validateComposition!=='function'||!proof.current()||!ownerCurrent())revoked=true;}
  catch{revoked=true;}
  return !revoked;
 };
 return Object.freeze({...(proof.profile?{profile:proof.profile}:{}),current,validateComposition(value:Readonly<ProgramCompositionObservation>){
  if(!current())throw Error('creator_program_unavailable');
  try{proof.validateComposition(value);if(!current())throw Error('creator_program_unavailable');}
  catch(error){revoked=true;throw error;}
 }});
}
